<template>
    <div class="list-group-item d-flex flex-row align-items-center position-relative" @click="$emit('click')">
		<b-icon
			v-if="showRemove"
			icon="x"
			@click.stop="$emit('remove')"
			class="position-absolute"
			style="cursor: pointer; top: 1rem; right: 1rem;"
		/>
		<p class="mb-0">
			<template v-if="formResponse.savedreport">
				<template v-if="formResponse.num_users > 1">
					<template v-if="formResponse.savedreport.savedreport_title">
						{{formResponse.savedreport.savedreport_title}}:
					</template>
					<template v-else>
						{{$t('report-for')}}
					</template>
					{{formResponse.num_users}} {{$t('students')}}
				</template>
				<template v-else>
					<template v-if="formResponse.savedreport.savedreport_title">
						<strong class="mr-2">{{formResponse.savedreport.savedreport_title}}: {{ formResponse.savedreport.student_displayname }}</strong>
					</template>
					<template  v-else>
						<strong class="mr-2">{{$t('report-for')}} {{ formResponse.savedreport.student_displayname }}</strong>
					</template>
				</template>
			</template>
			<template v-else>
				<strong class="mr-2">{{ title }}</strong>
			</template>
			<span v-if="(formResponse.formresponse_abandoned == '1')" class="badge badge-secondary">{{$t('abandoned')}}</span>
			<br />
			<span class="small">
				<template v-if="Number(formResponse.formresponse_completed) == 1 && formResponse.formresponse_dateofresponse">
					{{ isNaN(formResponse.formresponse_dateofresponse) ? formResponse.formresponse_dateofresponse : this.$datetime.getLocaleStringFromTimeStamp(formResponse.formresponse_dateofresponse, false) }}
				</template>
				<template v-else>
					{{  isNaN(formResponse.created) ? formResponse.created : this.$datetime.getLocaleStringFromTimeStamp(formResponse.created, false) }}
				</template>
			</span>
				<span class="badge" :class="deadlineClass" v-if="showDeadline">{{ $t('deadline-colon') }} {{
					isNaN(formResponse.formResponse.formresponse_deadline) ? formResponse.formResponse.formresponse_deadline : this.$datetime.getLocaleStringFromTimeStamp(formResponse.formresponse_deadline, false) }}
				</span>
			<br />
			<template v-if="formResponse.formresponse_message">
				<span class="small">{{ $stringhelper.truncate(formResponse.formresponse_message, 250 , '...') }}</span>
				<br />
			</template>
			<span class="small">
				{{ $t('user-colon') }} <strong>{{ user_displayname }}</strong>
				<template v-if="userreview_displayname">
					<template v-if="(formResponse.formresponse_reviewed == '1')">
						<span class="badge badge-pill badge-success ml-1">
							{{ $t('reviewed-by') }}
							<strong>{{ userreview_displayname }}</strong>
						</span>
					</template>
					<template v-else>
						<span class="text-subtle ml-1">&#183;</span>
						{{ $t('review-colon') }} <strong>{{ userreview_displayname }}</strong>
					</template>
				</template>
				<template v-if="formResponse.usersignoff_displayname">
					<template v-if="(formResponse.formresponse_signedoff == '1')">
						<span class="badge badge-pill badge-success ml-1">
							{{ $t('signed-off-by') }}
							<strong>{{ formResponse.usersignoff_displayname }}</strong>
						</span>
					</template>
					<template v-else>
						<span class="text-subtle ml-1">&#183;</span>
						{{ $t('signoff-colon') }}
						<strong>{{ formResponse.usersignoff_displayname }}</strong>
					</template>
				</template>
				<template v-if="awaitingFeedbackFromDisplayName">
					<br /><span class="text-subtle">{{ $t('awaiting-feedback-from-colon') }} <strong>{{ awaitingFeedbackFromDisplayName }}</strong></span>
				</template>
			</span>
		</p>
    </div>
</template>

<script>
export default {
    props: {
        formResponse: Object,
		showRemove: Boolean,
    },
    mounted() {
		// This component has to work with the list endpoint, which returns fields with the table name prepended,
		// and the activitylog endpoint, whose form response children do not have their field names prepended by the table.
		Object.keys(this.formResponse).forEach(key => {
			this.formResponse[`formresponse_${key}`] = this.formResponse[key];
		})
		if (this.formResponse.userreview_id) this.formResponse.userreviewid = this.formResponse.userreview_id

        this.getUserDetails()
		if (!this.user_displayname) this.$users.getDisplayName.call(this, this.formResponse.userfrom_id).then(name => {
			this.user_displayname = name
		})
		if (!this.userreview_displayname) this.$users.getDisplayName.call(this, this.formResponse.userreview_id).then(name => {
			this.userreview_displayname = name
		})
		if (!this.usersignoff_displayname) this.$users.getDisplayName.call(this, this.formResponse.usersignoffrom_id).then(name => {
			this.usersignoff_displayname = name
		})
    },
	data() {
		return {
			user_displayname: this.formResponse.user_displayname,
			userreview_displayname: this.formResponse.userreview_displayname,
			usersignoff_displayname: this.formResponse.usersignoff_displayname,
		}
	},
    methods: {
        getUserDetails() {
			this.$users.getUserById.call(this, this.formResponse.student).then((user) => {
				this.user = user;
			});
		},
    },
    computed: {
    	title() {
			if(this.formResponse.form){
				return this.formResponse.form.title;
			}
			if(this.formResponse.form_title){
				return this.formResponse.form_title;
			}
			if(this.formResponse.formresponse_data){
				return this.formResponse.formresponse_data.title;
			}
    		return '';
    	},
		showDeadline() {
			if(this.formResponse.formresponse_deadline){
				if(this.formResponse.formresponse_completed == false){
					return true;
				}
			}
			return false;
		},
		awaitingFeedbackFromDisplayName() {
			const me = this.$UserSession.getValue('id');
			const fr = this.formResponse;
			if(fr.formresponse_completed != '1' && fr.user_id != me) {
				return fr.user_displayname;
			} else if(fr.formresponse_completed == '1' && fr.formresponse_signedoff != '1' && fr.usersignofffrom_id != me) {
				return fr.usersignoff_displayname;
			}
			return null;
		},
		deadlineClass(){
			var now = Date.now() / 1000;
			if(this.formResponse.formresponse_deadline < now){
				return 'badge-danger';
			}
			if(this.formResponse.formresponse_deadline < now + (3600*24*3)){
				return 'badge-warning';
			}
			return 'badge-info';
		},
    }
}
</script>
